import posthog from "posthog-js"

/**
 * The `notify-on-active-chat` flag keeps the desktop toast (and its sound) for
 * a message that lands in the chat the dispatcher already has open and focused.
 *
 * By default that toast is skipped: the message is on screen, so a toast on top
 * of it is noise. Some offices work the other way round — Slickshift stays on
 * top with the busiest room open all day, and the toast is how they notice a
 * new message at all. The flag is targeted per vhost in PostHog, so the quiet
 * behaviour stays the default.
 *
 * Read synchronously because the caller is a thunk, not a render. PostHog
 * resolves flags async, so never cache the result.
 */
export const NOTIFY_ON_ACTIVE_CHAT_FLAG = "notify-on-active-chat"

export const isNotifyOnActiveChatEnabled = (): boolean =>
  posthog.isFeatureEnabled(NOTIFY_ON_ACTIVE_CHAT_FLAG) === true
